import type { App } from "vue"
import { vTutorial } from "./tutorial"

export function registerDirectives(app: App) {
    app.directive("tutorial", vTutorial)
}